import React from 'react';
import './style.css';
import citrusFruit from '../../assets/citrus-fruit.png';

// Unser Geschenk ist es mit euch zu feiern. Solltet ihr uns
// dennoch etwas schenken wollen, freuen wir uns über einen
// finanziellen Beitrag für den Start in unserer Eheleben
// und die Flotterwochen

export class Gift extends React.Component {
    render() {
        return (
            <div id="gift-screen">
                <div className="gift-container">
                    <div className="gift-image-top-container">
                        <div className="gift-image-left-container">
                            <img src={citrusFruit} className="citrus-fruit-left" alt="Citrus fruit" />
                        </div>
                        <div className="gift-image-right-container">
                            <img src={citrusFruit} className="citrus-fruit-right" alt="Citrus fruit" />
                        </div>
                    </div>
                    <div className="gift-text-container">
                        {/* <div className="gift-text-content">
                            Unser Geschenk ist es mit euch zu feiern. <br /> <br /> Solltet ihr uns dennoch zusätzlich
                            etwas schenken wollen, freuen wir uns über einen finanziellen Beitrag für den Start in
                            unserer Eheleben und die Flotterwochen
                        </div> */}
                        <div className="gift-text-content">
                            <div className="gift-upper-text-content">UNSER GESCHENK IST ES, MIT EUCH ZU FEIERN.</div>

                            <div className="gift-lower-text-content">
                                SOLLTET IHR UNS DENNOCH ZUSÄTZLICH ETWAS SCHENKEN WOLLEN, FREUEN WIR UNS ÜBER EINEN
                                FINANZIELLEN BEITRAG FÜR DEN START IN UNSER EHELEBEN UND DIE FLITTERWOCHEN
                                <br />
                                🍹😎🏝️
                            </div>
                        </div>
                    </div>
                    <div className="gift-image-bottom-container">
                        <div className="gift-image-left-container">
                            <img src={citrusFruit} className="citrus-fruit-left" alt="Citrus fruit" />
                        </div>
                        <div className="gift-image-right-container">
                            <img src={citrusFruit} className="citrus-fruit-left" alt="Citrus fruit" />
                        </div>
                    </div>
                    {/* <div className="gift-divider"></div> */}
                </div>
            </div>
        );
    }
}
